module.exports = __webpack_public_path__ + "static/media/customerBanner3.ec537852.svg";